module.exports = __webpack_public_path__ + "static/media/Circle.72266671.svg";